import ApiService from "@/core/services/api.service";
import { BaseService } from "@/components/Tools/baseService";

let url = process.env.VUE_APP_API_ADMIN;

class Project extends BaseService {
  getAll(params, filter = []) {
    let optionalHeaders = {};
    let filterParams = this.getParams(filter, params);
    let options = new URLSearchParams(params).toString();

    return ApiService.get(
      url,
      "projects?" + options + filterParams,
      optionalHeaders
    );
  }

  get(id) {
    return ApiService.get(url, "projects/" + id);
  }

  store(data) {
    return ApiService.post(url + "/projects", data);
  }

  update(id, data) {
    return ApiService.post(url + "/projects/" + id, data);
  }

  delete(id) {
    return ApiService.delete(url + "/projects/" + id);
  }

  destroyIntegration(id) {
    return ApiService.delete(url + "/projects/scma/" + id);
  }
}

export default new Project();
